import { RecoilRoot } from 'recoil'
import { Route, Routes } from 'react-router-dom'
import { NewForm } from './FormGenericHooks/lib/Components/NewForm/NewForm'
import { FormGeneric } from './FormGenericHooks/lib/Components/FormGeneric/FormGeneric'
import RecoveryPage from './FormGenericHooks/RecoveryPage'
import ClearPage from './FormGenericHooks/ClearPage'
import ReviewDashboardPage from './FormGenericHooks/ReviewDashboard'

export const FormGenericRoutesWrapper = () => {
    return (
        <RecoilRoot>
            <Routes>
                <Route
                    path='form/:formId/:customerAssetTypeID/:serviceType'
                    element={<FormGeneric />}
                />
                <Route path='form/:formType' element={<NewForm />} />
                <Route path='record/:recordId' element={<FormGeneric />} />
                <Route path='recoverRecord/:recoveryId' element={<FormGeneric />} />
                <Route path='recover' element={<RecoveryPage />} />
                <Route path='clear' element={<ClearPage />} />
                <Route path='review' element={<ReviewDashboardPage />} />
            </Routes>
        </RecoilRoot>
    )
}
